import {Popup, Position, ToolbarItem} from 'devextreme-react/popup';
import {useEEToolAdapterContext} from "../contexts/eeToolAdapterContext";
import {SelectBox} from "devextreme-react/select-box";
import {NumberBox} from "devextreme-react/number-box";
import {useRef, useState} from "react";

export function CookTopSplashPopupControl() {
    const adapterContext = useEEToolAdapterContext()
    const refCookTopSplashHeight = useRef<NumberBox>(null);
    const refCookTopSplashWidth = useRef<NumberBox>(null);

    const getOKButtonOptions = {
        stylingMode: 'contained',
        text: 'OK',
        onClick: () => {
            adapterContext.handleCookTopSplash(refCookTopSplashWidth.current?.instance.option('value') ?? 0, refCookTopSplashHeight.current?.instance.option('value') ?? 0);
        },
    };

    const getCloseButtonOptions = {
        stylingMode: 'contained',
        text: 'Close',
        type: 'normal',
        onClick: () => adapterContext.hidePopupCookTopSplash()
    };

    if (!adapterContext.popupCookTopSplashVisible)
        return <></>;

    return (
        <>
            <Popup
                title='Enter Width/Height of CookTop Splash'
                visible={adapterContext.popupCookTopSplashVisible}
                width={adapterContext.popupSize.width}
                height={adapterContext.popupSize.height}
                hideOnOutsideClick={true}
                showCloseButton={true}
                onHidden={() => adapterContext.hidePopupCookTopSplash()}
            >
                <Position at={'left top'} my={'left top'} offset={{
                    x: adapterContext.popupLocation.left,
                    y: adapterContext.popupLocation.top
                }}></Position>
                <ToolbarItem
                    widget="dxButton"
                    toolbar="bottom"
                    location="after"
                    options={getOKButtonOptions}
                />
                <ToolbarItem
                    widget="dxButton"
                    toolbar="bottom"
                    location="after"
                    options={getCloseButtonOptions}
                />
                <div>
                    <div className="dx-field">
                        <NumberBox
                            defaultValue={adapterContext.cookTopSplashWidth}
                            width={'100%'}
                            label='Width (in.)'
                            labelMode={'outside'}
                            ref={refCookTopSplashWidth}
                        />
                    </div>
                    <div className="dx-field">
                        <NumberBox
                            defaultValue={adapterContext.cookTopSplashHeight}
                            width={'100%'}
                            label='Height (in.)'
                            labelMode={'outside'}
                            ref={refCookTopSplashHeight}
                        />
                    </div>
                </div>
            </Popup>
        </>
    );
}
